<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="user-list-cbt ace-list-page">
        <div class="user-list-header ace-list-header">
          <div class="bread-crumbs project-font">
            <span class="users-title ace-list-title">{{ pageTitle }}</span>
          </div>
          <div class="header-actions ace-list-actions">
              <app-breadcrumb [items]="[{ label: pageTitle }]"></app-breadcrumb>

          </div>
        </div>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible" role="alert">
        {{ errorMessage }}
        <button type="button" class="btn-close" (click)="errorMessage = null"></button>
      </div>

      <div *ngIf="loading" class="text-center py-4 project-font">
        {{ 'Loading...' | aceTranslate }}
      </div>

      <ng-container *ngIf="!loading">
        <div class="mb-3">
          <app-metric-cards [cards]="metricCards"></app-metric-cards>
        </div>

        <div *ngIf="!cards.length || !needsGradingBaseCards.length" class="card corrections-empty-card">
          <div class="card-body text-center py-4">
            <div class="text-muted">
              {{ !cards.length ? ('No corrections assigned yet.' | aceTranslate) : ('No assessments in the selected workflow state.' | aceTranslate) }}
            </div>
          </div>
        </div>

        <div class="marking-tab-shell" *ngIf="cards.length && needsGradingBaseCards.length">
          <div class="marking-toolbar">
            <div class="marking-toolbar__controls">
              <app-input
                class="marking-toolbar__control marking-toolbar__control--search"
                [hasLabel]="false"
                inputType="text"
                [inputPlaceholder]="'Search assessments...' | aceTranslate"
                [parentFormGroup]="filterForm"
                parentFormControl="searchTerm">
              </app-input>
            </div>
          </div>

          <app-tab-view class="marking-tabview">
            <app-tab-panel *ngFor="let tab of assessmentTypeTabs; trackBy: trackByAssessmentTypeTab" [header]="tab.label + ' (' + tab.count + ')'">
              <ng-container
                *ngTemplateOutlet="cardsListTpl; context: { cards: getNeedsGradingCardsForType(tab.value) }">
              </ng-container>
            </app-tab-panel>
          </app-tab-view>
        </div>

        <ng-template #cardsListTpl let-tabCards="cards">
          <div *ngIf="!tabCards.length" class="card corrections-empty-card">
            <div class="card-body text-center py-4">
              <div class="text-muted">{{ 'No assessments in the selected workflow state.' | aceTranslate }}</div>
            </div>
          </div>

          <section class="workflow-panel mb-3" *ngIf="tabCards.length">
          <div class="cards-grid">
            <article class="correction-card" *ngFor="let card of tabCards; trackBy: trackByCorrectionCard">
              <div [class]="assessmentIconClass(card.assessmentType)" aria-hidden="true">
                <i [class]="assessmentTypeIcon(card.assessmentType)"></i>
              </div>

              <div class="correction-card__main">
                <div class="correction-card__title-wrap">
                  <h6 class="correction-card__title mb-1">{{ getCardAssessmentDisplayName(card) }}</h6>
                  <div class="correction-card__course">{{ getCardCourseDisplayName(card) }}</div>
                  <div class="correction-card__schedule">
                    <i class="ri-calendar-line" aria-hidden="true"></i>
                    {{ getCardScheduleDisplay(card) }}
                  </div>
                </div>
              </div>

              <div class="correction-card__badges correction-card__badges--side">
                <span [class]="assessmentTypeBadgeClass(card.assessmentType)">
                  {{ assessmentTypeLabel(card.assessmentType) }}
                </span>
                <span [class]="roleBadgeClass(card.markerRole)">
                  {{ card.markerRole === 'SECOND_MARKER' ? ('Second Marker' | aceTranslate) : ('First Marker' | aceTranslate) }}
                </span>
              </div>

              <div class="correction-card__meta">
                <span class="pending-pill">
                  {{ card.pendingLearnersCount }} {{ 'Pending' | aceTranslate }}
                </span>
              </div>

              <div class="correction-card__footer">
                <app-button
                  buttonType="button"
                  buttonMainStyle="btn btn-primary correction-card__grade-btn"
                  [buttonText]="cardActionLabel"
                  (btnClick)="openCorrections(card)">
                </app-button>
              </div>
            </article>
          </div>
          </section>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
